module.exports = __webpack_public_path__ + "static/media/pied-piper.80fccf27.svg";